(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["influencers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Tabs ---------- */
    function activate(tab) {
      var root = tab.closest('.ifav');
      if (!root) return;
      var id = tab.getAttribute('data-ifav-tab');
      root.querySelectorAll('.ifav__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      root.querySelectorAll('.ifav__panel').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-ifav-panel') === id); });
    }
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.ifav__tab');
      if (tab) activate(tab);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var tab = document.querySelector('.ifav__tab[data-ifav-tab="' + e.detail.blockId + '"]');
      if (tab) activate(tab);
    });

    /* ---------- Add to cart + open drawer ---------- */
    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    }
    function refreshSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (html == null) return;
        var wrapper = document.getElementById('shopify-section-' + id);
        if (wrapper) { wrapper.innerHTML = html; return; }
        var el = document.getElementById(id);
        if (el) {
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById(id);
            el.innerHTML = fresh ? fresh.innerHTML : html;
          } catch (e) { el.innerHTML = html; }
        }
      });
    }
    function openCart() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.classList.remove('is-empty');
        try { drawer.open(); return true; } catch (e) {}
      }
      ['cart:open', 'cart-drawer:open', 'drawer:open', 'cart:refresh'].forEach(function (ev) {
        document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      var toggle = document.querySelector(
        '#cart-icon-bubble, [aria-controls="CartDrawer"], button[aria-controls="cart-drawer"],' +
        ' .js-drawer-open-cart, [data-cart-drawer-toggle], .header__icon--cart, .site-header__cart, a[href$="/cart"]'
      );
      if (toggle) { try { toggle.click(); return true; } catch (e) {} }
      return false;
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ifav-add]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.innerHTML = '<span class="ifav__spin"></span><span>Adding</span>'; }

      var body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-notification,cart-icon-bubble,cart-live-region-text');
      body.append('sections_url', window.location.pathname);

      fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) { throw res.data; }
          refreshSections(res.data.sections);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          openCart();
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = original; }
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = original; }
          if (err && err.description) { window.alert(err.description); }
          else { form.submit(); } /* hard fallback */
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
